/* eslint-disable max-lines */

import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import type { Renderable } from '@adornis/functional-lit/renderable.js';
import type { ILSThemeDefinition } from '@ils/theme/theme.js';
import type { Order } from '../../db/order.js';
import { squareIcon } from './squareIcon.js';

export const orderStatusIcon = (
  host: ChemistryLitElement<ILSThemeDefinition>,
  status: Order['status'],
  options: { size?: string; title?: string; onClick?: () => void; slotted?: Renderable; isSelected?: boolean },
) =>
  squareIcon(
    host,
    {
      issued: 'near_me',
      canceled: 'near_me_disabled',
      revoked: 'close',
      moved: 'content_copy',
      paid: 'check',
      failed: 'error',
      expired: 'timer_off',
      refund: 'undo',
    }[status],
    {
      ...options,
      color: {
        issued: host.colors.blue,
        canceled: host.colors.orange,
        revoked: host.colors.orange,
        moved: host.colors.neutral,
        paid: host.colors.green,
        failed: host.colors.orange,
        expired: host.colors.orange,
        refund: host.colors.red,
      }[status],
    },
  );
